<template>
  <div class="dummy-viewer text-sm-center">
    <img class="unknown" src="/images/idonia_unknown.svg"/>
    <p class="hint">{{$t('NoPreview')}}</p>
    <div>
      <v-btn class="accent white--text" raised @click.native="download">
        <v-icon left dark>file_download</v-icon>
        {{$t('Download')}}
      </v-btn>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'dummy-viewer',
    methods: {
      getURL () {
        let url = new URL('/api/document/' + this.$route.params.file_id + '/download', this.$config.apiUrl);
        if (this.$auth.idToken){
          url.searchParams.set('id_token', this.$auth.idToken)
        }
        if (this.$auth.accountID && this.$auth.token){
          url.searchParams.set('token', this.$auth.token)
          url.searchParams.set('account_id', this.$auth.accountID)
        }
        return  url.href
      },
      download () {
        window.open(this.getURL())
      }
    }
  }
</script>

<style lang="scss">
  .dummy-viewer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
  }

  .hint {
    display: block;
    text-align: center;
    font-size: 1.5rem;
    font-style: italic;
    color: #909090;
    margin-top: 5px;
    margin-bottom: 25px;
    overflow-wrap: normal;
    max-width: 350px;
  }

  .unknown {
    max-width: 350px;
    min-width: 250px;
    width: 350px;
    margin-bottom: 35px;
  }
</style>
